var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 19.29l-8.49-8.49a6.56 6.56 0 10-.71.71L19.29 20zM1 6.54a5.55 5.55 0 115.54 5.55A5.55 5.55 0 011 6.54z",
    fill: "#cca789"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgdmlld0JveD0iMCAwIDIwIDIwIj48cGF0aCBkPSJNMjAsMTkuMjksMTEuNTEsMTAuOGE2LjU2LDYuNTYsMCwxLDAtLjcxLjcxTDE5LjI5LDIwWk0xLDYuNTRhNS41NSw1LjU1LDAsMSwxLDUuNTQsNS41NUE1LjU1LDUuNTUsMCwwLDEsMSw2LjU0WiIgZmlsbD0iI2NjYTc4OSIvPjwvc3ZnPg==";
export { SvgSearch as ReactComponent };